$ = jQuery;

// Load components
import './js/components';

import './scss/main.scss';

import Courses from './js/frontend-my-account.js';

$( document ).ready(() => {
	new Courses();
});